import { report } from 'report';
import { PetId } from '../../Constants/Pets';
import { AnimationClipEvent } from '../../System/Animation/AnimationClip';
import { StartAnimationClip } from '../../System/Animation/AnimationHelper';
import { MovePet } from '../../System/Animation/Clip/MovePet';
import WorldSystem from '../../System/World/WorldSystem';
import { PetAnimations } from '../Helpers/Pets/PetAnimations';
import { PetsHelper } from '../Helpers/Pets/PetsHelper';
import Point from '../Point';
import ITask from './ITask';

export default class PetWalkTask implements ITask<WorldSystem> {
    private readonly currentWorldMaxLevel: number;
    private readonly endLevel: number;
    private readonly startLevel: number;
    private readonly petId: PetId;

    constructor(currentWorldMaxLevel: number, endLevel: number, startLevel: number, petId: PetId) {
        this.currentWorldMaxLevel = currentWorldMaxLevel;
        this.endLevel = endLevel;
        this.startLevel = startLevel;
        this.petId = petId;
    }

    public *execute(system: WorldSystem): IterableIterator<any> {
        const pet = system.pet;

        const petData = PetsHelper.getPetData(this.petId);
        if (!petData) {
            report('Missing pet data', {
                once: true,
                sampleRate: 0.1,
                tags: {
                    petID: this.petId,
                },
            });
            return;
        }
        const points: Point[] = [];

        for (let i = this.startLevel + 1; i <= this.endLevel; i++) {
            points.push(getNodePosition(i, this.currentWorldMaxLevel));
        }
        pet.stop();
        StartAnimationClip(
            new MovePet(pet, {
                points,
                exitAnimations: [PetAnimations.WALKING_TO_IDLE],
            }).once(AnimationClipEvent.COMPLETE, () => {
                pet.play(PetAnimations.IDLE);
            })
        );

        return;

        function getNodePosition(levelNumber: number, currentWorldMaxLevel: number): Point {
            const node = system.getLevelNode(levelNumber <= currentWorldMaxLevel ? levelNumber : currentWorldMaxLevel);
            const nodePos = node?.getPetPosition() ?? Point.Zero;
            if (!node) {
                report('Failed to find node position for pet walk task', {
                    once: true,
                    sampleRate: 0.1,
                    fingerprint: 'PetWalkTask:GetNodePosition:FailedToFindNode',
                    tags: {
                        levelNumber,
                        currentWorldMaxLevel,
                    },
                });
            }
            return Point.add(
                nodePos,
                levelNumber <= currentWorldMaxLevel ? petData.nodeWalkOffset : petData.nodeWalkNextWorldOffset,
                petData.positionOffset
            );
        }
    }
}
